// Warms the browser's image cache for a variant's gallery photo as soon as the shopper
// hovers or focuses the corresponding color/option swatch, so the product gallery does
// not show a loading state when the swatch is actually selected.
// This is purely additive: it does not touch how the gallery itself swaps images.

const preloadedSrcs = new Set();

function preloadImage(src, width) {
  if (!src || preloadedSrcs.has(src)) return;
  preloadedSrcs.add(src);

  try {
    const url = new URL(src, window.location.href);
    url.searchParams.set('width', width);
    const img = new Image();
    img.src = url.toString();
  } catch (error) {
    // Ignore malformed URLs — nothing to preload.
  }
}

function preloadFromAttribute(element, attribute, width) {
  const raw = element.getAttribute(attribute);
  if (!raw) return;

  try {
    const media = JSON.parse(raw);
    preloadImage(media && media.preview_image && media.preview_image.src, width);
  } catch (error) {
    // Ignore malformed JSON — nothing to preload.
  }
}

function handleSwatchInteraction(event) {
  const label = event.target.closest('.variant-picker label[for]');
  if (!label) return;

  const input = document.getElementById(label.htmlFor);
  if (!input) return;

  preloadFromAttribute(input, 'data-variant-media', 1200);
  preloadFromAttribute(input, 'data-variant-secondary-media', 1200);
}

document.addEventListener('mouseover', handleSwatchInteraction, { passive: true });
document.addEventListener('focusin', handleSwatchInteraction);
document.addEventListener('touchstart', handleSwatchInteraction, { passive: true });
